import React, { PureComponent } from 'react';
import Pagination from './Pagination';
import ResponsiveProvider from 'core/providers/ResponsiveProvider';
import ErrorBoundary from 'core/components/ErrorBoundary';

class PaginationContainer extends PureComponent {
	render () {
		return (
			<ErrorBoundary>
				<ResponsiveProvider>
					<Pagination {...this.props} />
				</ResponsiveProvider>
			</ErrorBoundary>
		);
	}
}

export default PaginationContainer;
